<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">

    </div>
    <div class="content-body">
      <section id="drag-area">
        <div class="row">
          <div class="col-md-12" *blockUI="'changelog'; message: 'Loading'">
            <m-card [options]="options" (reloadFunction)="reloadChangelog($event)">
              <ng-container mCardHeaderTitle>
                Fonksiyonlar
              </ng-container>
              <ng-container mCardBody>
               
               
                <table class="table table-bordered">
                  <thead>
                  <tr>
                   
                    <th>Adı</th>
                    <th>Türkçesi</th>
                  
                  </tr>
                </thead>
                  <tr *ngFor="let h of filteredhammeddeler">
                   
                    <td>{{h.name}}</td>
                    <td>{{h.turkishName}}</td>
                 
                   
                  </tr>
                
                </table>
              </ng-container>
            </m-card>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
